<div id="solution-main">
   <h2>Solución</h2>
   <div id="solution-content" [style.--bg-desktop]="'url(' + solution().img + ')'">

      <div id="solution-content-text">
         <h3 id="solution-content-title">{{solution().title}}</h3>
         <p>{{solution().text}}</p>
         <ul>
            @for (item of solution().textList; track $index) {
               <div class="list-text-container">
                  <fa-icon [icon]="check"></fa-icon>
                  <li>{{item}}</li>
               </div>
            }
         </ul>

         <div id="solution-content-bottom">
            <a [href]="solution().link">Más información</a>
         </div>
      </div>

   </div>
</div>


<div id="solution-main-mobile">
   <h2>Solución</h2>

   <div id="solution-content">

      <div id="solution-title-img" [style.--bg-mobile]="'url(' + solution().imgMobile + ')'">
         <div id="solution-content-title">
            <h3>{{solution().title}}</h3>
         </div>
      </div>
      <!-- <picture id="solution-image">
         <source [srcset]="solution().imgMobile" media="(max-width:768px)">
         <img [src]="solution().imgMobile">
      </picture> -->

      <div id="solution-content-text">
         <p>{{solution().text}}</p>

         <ul>
            @for (item of solution().textList; track $index) {
               <div class="list-text-container">
                  <fa-icon [icon]="check"></fa-icon>
                  <li><p>{{item}}</p></li>
               </div>
            }
         </ul>

         <div id="solution-content-bottom">
            <a [href]="solution().link">Más información</a>
         </div>

      </div>

   </div>
</div>